import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<this.MedicalHistoryBaseEditionForm @forcComponent={{this}} @patient={{@patient}} />", {
  moduleName: "core/components/medical-history/rhumato/index.hbs"
});